<template>
    <div id="app">
        <template v-if="onlyView">
            <router-view></router-view>
        </template>
        <template v-else>
            <MainHeader
                login-url="/api/v1.0/auth/"
                logout-url="/api/v1.0/auth/logout"
                user-data-url="/my_account"
                :user-data="user"
                :hoverable="false"
                :use-native-links="true"
                always-active-link="create"
            />

            <notifications></notifications>

            <transition name="fade">
                <loading-main v-if="loading"></loading-main>
                <router-view v-else></router-view>
            </transition>
            <Feedback />
            <MainFooter />
        </template>
        <SessionDialog />
    </div>
</template>

<script>
import MainHeader from '@bistudio/ylands-vue-components/src/components/Header';
import MainFooter from '@bistudio/ylands-vue-components/src/components/Footer';
import LoadingMain from '@/components/common/loading/LoadingMain';
import SessionDialog from '@/components/common/modal/SessionDialog';
import { mapGetters } from 'vuex';

export default {
    name: 'App',
    metaInfo: {
        title: 'Ylands Creative Club',
    },
    components: {
        MainHeader,
        MainFooter,
        LoadingMain,
        SessionDialog,
        Feedback: () =>
            import(
                /* webpackPrefetch: true */ '@/components/common/Feedback.vue'
            ),
    },
    computed: {
        ...mapGetters('user', {
            user: 'getUser',
            loading: 'loading',
        }),
        onlyView() {
            return this.$route.meta.onlyView;
        },
    },
};
</script>

<style lang="scss">
#app {
    background: #fff;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity $transition-values;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
